import { render } from "./AvaFabric.vue?vue&type=template&id=08e7bfea&scoped=true"
import script from "./AvaFabric.vue?vue&type=script&lang=js"
export * from "./AvaFabric.vue?vue&type=script&lang=js"

import "./AvaFabric.vue?vue&type=style&index=0&id=08e7bfea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e7bfea"]])

export default __exports__